import { render } from "./ContainerBlock.vue?vue&type=template&id=c035f75a"
import script from "./ContainerBlock.vue?vue&type=script&lang=js"
export * from "./ContainerBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__